import { ChatThread } from "@/schema"
import { useQuery, UseQueryOptions } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { ChatThreadParams, fetchChatThread, fetchChatThreads } from "./api"

export function useFetchChatThread(
  threadId: string,
  options?: Omit<UseQueryOptions<ChatThread, Error>, "queryKey" | "queryFn">
) {
  const getContext = useApiContext()
  return useQuery<ChatThread, Error>({
    queryKey: ["chat_thread", threadId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchChatThread(context, threadId)
    },
    enabled: !!threadId,
    ...options,
  })
}

export function useFetchChatThreads(
  params?: ChatThreadParams,
  options?: Omit<UseQueryOptions<ChatThread[], Error>, "queryKey" | "queryFn">,
  bookIdOverride?: string
) {
  const getContext = useApiContext(bookIdOverride)
  const queryKey =
    params?.chat_threadable_type && params?.chat_threadable_id
      ? ["chat_threads_list", params.chat_threadable_type, params.chat_threadable_id]
      : ["chat_threads_list"]

  return useQuery<ChatThread[], Error>({
    queryKey,
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchChatThreads(context, params)
    },
    ...options,
  })
}
